(function ($) {
  $.fn.pick = function (how_many) {
    var how_many = how_many || 4;

    // Picking random numbers without repeating.
    var index_array = [];
    var original_obj_size = this.size();
    for (var i = 0; i < original_obj_size; i++) {
      index_array.push(i);
    }

    var shuffle = function (v) {
      for (
        var j, x, i = v.length;
        i;
        j = parseInt(Math.random() * i), x = v[--i], v[i] = v[j], v[j] = x
      );
      return v;
    };
    var new_index_array = shuffle(index_array).slice(0, how_many);

    // Ditching unpicked elements and removing those from the returned set.
    return this.each(function (i) {
      if ($.inArray(i, new_index_array) === -1) {
        $(this).remove();
      }
    }).filter(function () {
      if (this.parentNode === null) {
        return false;
      } else {
        return true;
      }
    });
  };
})(jQuery);
